import app from 'reactPath/constants/app';
import bluramsNotAllowKeys from './blurams';
import easelifeNotAllowKeys from './easelife';
const mtaKeyAllowCheck = function (key) {
    if (app.isBluramsApp()) {
        return !bluramsNotAllowKeys.includes(key);
    } else if (app.isEaseLifeApp()) {
        return !easelifeNotAllowKeys.includes(key);
    }
    return true;
};

export default mtaKeyAllowCheck;